function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as o } from "react/jsx-runtime";
import { useTheme as n } from "../../hooks.js";
import { useIsInverseVariant as s } from "../../theme-variant-context.js";
import { vars as a } from "../../skins/skin-contract.css-mistica.js";
const h = (_param)=>{
    var { color: t , size: c = 24  } = _param, r = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const i = s(), e = t !== null && t !== void 0 ? t : i ? a.colors.inverse : a.colors.neutralHigh, { skinName: l  } = n();
    return l.match(/^o2/i) ? /* @__PURE__ */ o("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, r), {
        children: /* @__PURE__ */ o("path", {
            fill: e,
            d: "M11.68 2.054a.86.86 0 01.6 0c.245.108 5.716 2.752 5.72 9.579 0 3.608-1.59 5.648-2.929 6.72a6.999 6.999 0 01-2.364 1.323v1.608A.713.713 0 0112 22a.713.713 0 01-.707-.716v-1.608C9.81 19.176 6 17.281 6 11.633c0-6.735 5.32-9.399 5.669-9.573l.011-.006zm1.023 5.647v10.44c1.377-.573 3.88-2.216 3.884-6.504 0-5.075-3.53-7.507-4.587-8.115-1.058.604-4.587 3.004-4.59 8.115 0 4.288 2.502 5.931 3.88 6.503V7.701c0-.392.32-.715.706-.715.387 0 .707.32.707.715z"
        })
    })) : /* @__PURE__ */ o("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, r), {
        children: /* @__PURE__ */ o("path", {
            fill: e,
            d: "M2.184 4.89v2.52h1.075l-1.072.003c0 2.902 1.602 4.844 4.515 4.844 1.229 0 2.225-.285 2.965-.833.197.424.372.882.525 1.374.675 2.16.807 4.504.894 6.053l.002.037c.035.604.063 1.082.115 1.406a.54.54 0 00.526.453h.01a.542.542 0 00.531-.453c.13-.804.527-3.244 1.499-5.569.118-.282.24-.551.365-.808.757.65 1.825.99 3.173.99 2.8 0 4.39-1.466 4.508-4.137a.535.535 0 00.007-.087V7.61c0-.896-.736-1.624-1.641-1.624h-2.876c-2.909 0-4.51 1.586-4.51 4.462 0 1.022.202 1.88.593 2.562-.216.405-.421.839-.613 1.3a21.048 21.048 0 00-.776 2.217c-.187-1.858-.578-4.063-1.532-5.936.492-.725.747-1.676.747-2.835 0-2.905-1.602-4.504-4.512-4.504v1.075c2.314 0 3.437 1.12 3.437 3.426 0 .697-.103 1.286-.31 1.768-.77-1.108-1.807-2.02-3.205-2.555a.54.54 0 00-.387 1.008c1.185.454 2.159 1.286 2.91 2.486-.567.481-1.38.719-2.445.719-2.314 0-3.44-1.464-3.44-3.769H3.26V4.893a.57.57 0 01.566-.566H6.7V3.252H3.825c-.902 0-1.638.734-1.641 1.638zm15.124 2.166h2.876c.313 0 .568.249.568.554v2.866c-.01 2.256-1.139 3.355-3.445 3.355-1.194 0-2.071-.293-2.642-.89.989-1.622 2.174-2.568 3.535-2.815a.538.538 0 10-.193-1.062c-1.204.219-2.294.868-3.24 1.927a9.102 9.102 0 00-.704.903c-.133-.415-.199-.898-.199-1.449 0-2.28 1.127-3.39 3.443-3.39h.001z"
        })
    }));
}, u = h;
export { u as default };
